import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import { GlobalClassName } from '@/shared/constant/GlobalClassName';
import type { SidebarTreeNode } from '@/shared/constant/sidebar-tree/SidebarTreeNode';
import { ModelType } from '@tarslib/types/lib/common';
import { FoxIconSchemagroup } from 'aui-biz-icons';
import clsx from 'clsx';
import React from 'react';
import { SidebarApi } from '../sidebar-api/SidebarApi';
import { SidebarDataSchema } from '../sidebar-data-schema/SidebarDataSchema';
import { SidebarDoc } from '../sidebar-doc/SidebarDoc';
import { SidebarFolder } from '../sidebar-folder/SidebarFolder';

export type SidebarTreeListProps = {
  list: SidebarTreeNode[];
  indentation: number;
  firstLevelSelectedApiFolderId?: number;
  className?: string;
  isHidden: boolean;
};

export const SidebarTreeList = React.memo(function SidebarTreeListComponent(
  props: SidebarTreeListProps,
) {
  const { list, className, indentation, firstLevelSelectedApiFolderId, isHidden } = props;
  const clientI18n = useClientI18nModelStore((x) => x.clientI18n);

  if (!list.length) {
    return null;
  }

  return (
    <ul className={clsx(GlobalClassName.SidebarItemList, className)}>
      {list.map((x, i) => {
        if (x.type === ModelType.Doc) {
          return <SidebarDoc value={x} key={x.key} isHidden={isHidden} />;
        } else if (x.type === ModelType.ApiFolder) {
          const dataSchemaRootFolder =
            x.folderType === ModelType.ApiSchemaFolder &&
            (indentation === 0 || indentation === 1) &&
            x.name === undefined;
          return (
            <SidebarFolder
              value={x}
              key={x.key}
              indentation={indentation}
              index={i}
              firstLevelSelectedApiFolderId={firstLevelSelectedApiFolderId}
              isHidden={isHidden}
              suffixIcon={
                dataSchemaRootFolder ? <FoxIconSchemagroup className="-ml-1 pt-1" /> : undefined
              }
              displayName={dataSchemaRootFolder ? clientI18n('api.label.dataSchema') : undefined}
            />
          );
        } else if (x.type === ModelType.ApiSchema) {
          return <SidebarDataSchema value={x} key={x.key} />;
        } else {
          return <SidebarApi value={x} key={x.key} isHidden={isHidden} />;
        }
      })}
    </ul>
  );
});
